import { config, server } from "..";

export const addRedirect = (token: string, url: string) => {
  return server.post(`/redirect`, { token, url }, config);
};

export const getRedirect = (id: string) => {
  return server.get(`/redirect/${id}`, config);
};
